export default "__VITE_ASSET__C381$UiM__"